import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const faqs = [
  { q: "How do I get an expedited passport in Great Falls, Montana?", a: "Great Falls residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Seattle, 490+ miles west via I-90." },
  { q: "Can Malmstrom AFB personnel use Fast Passport Center?", a: "Yes — Fast Passport Center serves all Great Falls residents including military personnel and their families stationed at Malmstrom AFB. Our mail-in service works perfectly for service members who need expedited civilian passports." },
];

export default function GreatFallsPage() {
  return (
    <>
      <CitySEOHead
        city="Great Falls"
        state="Montana"
        stateAbbr="MT"
        route="/cities/great-falls"
        title="Emergency Passport Great Falls, MT — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Great Falls, Montana. Serving Cascade County, Malmstrom AFB, Fort Benton, and surrounding areas. As fast as 24 hours — no Denver trip needed."
        geoPlacename="Great Falls, Montana"
        geoPosition="47.5003;-111.3008"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Montana"
        statePageRoute="/states/montana"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}